module.exports = __webpack_public_path__ + "static/media/feeling-happy.8ec75563.svg";